import { Component, inject, type OnDestroy, type OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DictionaryService } from '@core/locale/dictionary.service'
import { LocaleService } from '@core/locale/locale.service'
import { type Display } from '@core/type/display'
import { type THEME_TYPE } from '@core/type/theme'
import { IS_SET } from '@core/util/check.util'
import { combineLatest } from 'rxjs'
import { filter, takeWhile, tap } from 'rxjs/operators'

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  MAT_DIALOG_DATA = inject(MAT_DIALOG_DATA)
  MatDialogRef = inject(MatDialogRef)
  LocaleService = inject(LocaleService)
  DictionaryService = inject(DictionaryService)

  bAlive = false

  themeType: THEME_TYPE = 'primary'

  display: Display = {
    cache: {
      title: '',
      message: '',
      cancel: '',
      confirm: ''
    },
    update: {
      all: () => {
        for (const k of Object.keys(this.display.cache)) {
          this.display.cache[k] = this.DictionaryService.get({ k })
        }
      }
    }
  }

  ngOnInit (): void {
    this.bAlive = true

    combineLatest([this.LocaleService.localeBS, this.LocaleService.tzBS, this.DictionaryService.mLastRefreshBS]).pipe(
      takeWhile(() => this.bAlive),
      filter(([locale, tz, mLastRefresh]) => IS_SET(mLastRefresh)),
      tap(() => { this.display.update.all() })
    ).subscribe()

    const title = this.MAT_DIALOG_DATA.title
    this.display.cache.title = title

    const message = this.MAT_DIALOG_DATA.message
    this.display.cache.message = message

    const themeType = this.MAT_DIALOG_DATA.themeType
    if (IS_SET(themeType)) {
      this.themeType = themeType
    }

    const cancelText = this.MAT_DIALOG_DATA.cancelText
    if (IS_SET(cancelText)) {
      this.display.cache.cancel = cancelText
    }

    const confirmText = this.MAT_DIALOG_DATA.confirmText
    if (IS_SET(confirmText)) {
      this.display.cache.confirm = confirmText
    }
  }

  confirm (): void {
    this.MatDialogRef.close({ bConfirmed: true })
  }

  ngOnDestroy (): void {
    this.bAlive = false
  }
}
